export default {
  data () {
    return {
      didActions: false,
      isFormChanged: false,
      confirmDiscardModal: {
        show: false,
      },
      routeTo: null,
    }
  },

  computed: {
    isLegacyForm () {
      if (this.ready !== undefined || this.edited !== undefined) {
        return true
      }
      return false
    },
    isModernForm () {
      if (this.isSubmitted !== undefined) {
        return true
      }
      return false
    },
  },

  watch: {
    form: {
      handler: function () { this.handleFormChange() },
      deep: true,
    },
    isSubmitted: function () {
      if (this.isModernForm) {
        this.setStateFormReset()
      }
    },
    edited: function () {
      if (this.isLegacyForm) {
        this.setStateFormReset()
      }
    },
  },

  beforeRouteLeave (to, from, next) {
    if (this.routeTo !== null) {
      return next()
    }

    if (to.query.ignoreDiscardAlert === true) {
      return next()
    }

    if (this.isFormChanged) {
      this.routeTo = {
        name: to.name,
        hash: to.hash,
        params: to.params,
        query: to.query,
      }
      this.onOpenDiscardModal()
      return next(false)
    }

    next()
  },

  mounted () {
    window.addEventListener('mousedown', this.handleMouseDown)
    window.addEventListener('keypress', this.handleKeypress)
    window.addEventListener('beforeunload', this.handleCloseTab)
  },

  destroyed () {
    window.removeEventListener('mousedown', this.handleMouseDown, false)
    window.removeEventListener('keypress', this.handleKeypress, false)
    window.removeEventListener('beforeunload', this.handleKeypress, false)
  },

  methods: {
    handleFormChange () {
      // console.log('\nform change function is called')
      const isReady = (() => {
        if (this.loading !== undefined) {
          return !this.loading
        }
        if (this.ready !== undefined) {
          return this.ready
        }
        return true
      })()
      if (isReady && this.didActions) {
        this.setStateFormChanged()
      } else {
        this.setStateFormReset()
      }
    },
    handleMouseDown () {
      this.didActions = true
    },
    handleKeypress () {
      this.didActions = true
    },
    handleCloseTab (event) {
      try {
        if (this.isFormChanged) {
          event.returnValue = this.$t('message.confirmunsavedchanges')
          return this.$t('message.confirmunsavedchanges')
        }
      } catch (e) {}
    },
    setStateFormChanged () {
      this.isFormChanged = true
      // console.log('form changed')
    },
    setStateFormReset () {
      this.didActions = false
      this.isFormChanged = false
      // console.log('reset state')
    },
    onOpenDiscardModal () {
      this.confirmDiscardModal.show = true
    },
    handleDiscardCancleModal () {
      this.confirmDiscardModal.show = false
      this.routeTo = null
    },
    handleDiscardConfirmModal () {
      this.confirmDiscardModal.show = false
      this.$router.push({
        ...this.routeTo,
      }).catch(() => {})
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/discardForm.js